import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';
import LabeledInput from '../Common/LabeledInput';
import { FormValues } from '../../utils/validations/clientDetailsForm';

export interface GroupClientDetailFormProps {
  formik: FormikProps<FormValues>;
}
function GroupClientDetailForm({ formik }: GroupClientDetailFormProps) {
  const { t } = useTranslation();
  return (
    <>
      {/* First Row: Group Name */}
      <Grid item sm={12}>
        <LabeledInput
          label={t('addNewClient.groupName')}
          id="group-name"
          type="text"
          name="groupName"
          value={formik.values.firstName}
          handleChange={(e) => formik.handleChange('firstName')(e.target.value)}
          onBlur={formik.handleBlur}
          error={formik.errors.firstName}
          placeholder={t('addNewClient.groupName')}
        />
      </Grid>

      {/* Second Row: Description */}
      <Grid item sm={12}>
        <LabeledInput
          label={t('addNewClient.description')}
          id="description"
          type="text"
          value={formik.values.description}
          handleChange={(e) => formik.handleChange('description')(e.target.value)}
          onBlur={formik.handleBlur}
          error={formik.errors.description}
          placeholder={t('addNewClient.description')}
          multiline
          minRows={3}
        />
      </Grid>
    </>
  );
}
export default GroupClientDetailForm;
